import { render } from "./TransitionSection.vue?vue&type=template&id=a29cfb3a&scoped=true"
const script = {}

import "./TransitionSection.vue?vue&type=style&index=0&id=a29cfb3a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.11_vue@3.5.11_typescript@5.6.3__webpack@5.106.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a29cfb3a"]])

export default __exports__